/**
 * Icone social monocromatiche, stesso stile stroke-based (viewBox 24,
 * stroke="currentColor") di ogni altra icona del sito (lucide-react) —
 * ricostruite a mano perché la versione installata di lucide-react non
 * include più i loghi brand (rimossi dal pacchetto per motivi di licenza).
 * Solo le piattaforme davvero in uso: aggiungerne una nuova è una voce in
 * più in SOCIAL_ICON_MAP, non un nuovo componente per ogni chiamante.
 */
function IconBase({ size = 14, className = '', children }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className={className}
    >
      {children}
    </svg>
  );
}

function FacebookIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </IconBase>
  );
}

function InstagramIcon(props) {
  return (
    <IconBase {...props}>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </IconBase>
  );
}

const SOCIAL_ICON_MAP = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
};

/**
 * Risolve un'icona dal nome piattaforma (case-insensitive) — funzione, non
 * componente: chiamata direttamente ritorna `null` per una piattaforma non
 * mappata, non un elemento React "vuoto" (che sarebbe comunque un oggetto
 * troncabile — `s.icon || s.label` in SiteFooter smetterebbe di ricadere
 * sul testo, perché un elemento esiste sempre anche se renderizza nulla).
 */
export function getSocialIcon(platform, size = 14) {
  const Icon = SOCIAL_ICON_MAP[(platform || '').trim().toLowerCase()];
  return Icon ? <Icon size={size} /> : null;
}
